import { Plus } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/ui-components/Button'
import { TabContent, TabItem, Tabs } from '@/ui-components/Tabs'
import { CardsTable } from '@/views/Cards/CardsTable'
import IssueCardModal from '@/views/components/IssueCardModal'

export const Cards = () => {
  const [isIssueCardModalOpen, setIsIssueCardModalOpen] = useState(false)

  return (
    <>
      <div className="space-y-8">
        <div className="flex items-center justify-between">
          <Tabs>
            <TabItem current={true}>Cards</TabItem>
            <TabItem
              current={false}
              to="/cards/cardholders"
            >
              Cardholders
            </TabItem>
          </Tabs>
          <Button
            color="primary"
            onClick={() => setIsIssueCardModalOpen(true)}
          >
            <Plus data-slot="icon" />
            Issue Card
          </Button>
        </div>
        <TabContent isActive={true}>
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-bold text-primary-900 dark:text-primary-100">Virtual Cards</h2>
          </div>
          <CardsTable />
        </TabContent>
      </div>

      <IssueCardModal
        isOpen={isIssueCardModalOpen}
        onClose={() => setIsIssueCardModalOpen(false)}
      />
    </>
  )
}

export default Cards
